import { atom } from 'jotai';

export type ImageInAtom = {
  id: string;
  originalImage: string;
  originalImageId?: string;
  renderedImage?: string;
  watermarkApplied?: boolean;
  fileType: string;
  file: File | null;
};

export const imageIdFromParamsAtom = atom<string | undefined>();
export const uploadedImagesAtom = atom<ImageInAtom[]>([]);

export const selectedImageAtom = atom<ImageInAtom>();
export const selectedPreviewImageAtom = atom<ImageInAtom>();
